import React from 'react';
import './index.scss';
import PcConfOdItem from '../PcConfOdItem';

const PcConfTitle = ({
  text,
  list = [],
  icon,
  comment,
}) => {
  const ShowList = ({ list: detail }) => {
    return (
      <div className="">
        {detail.map(data => (
          <span key={data.text} className="">
            <PcConfOdItem
              text={data.text}
              children={data.children}
              modify={data.modify}
              changeModifyMode={data.modifyLinks}
            />
          </span>
        ),
        )}
      </div>
    );
  };

  return (
    <div className="PcConfTitle">
      <div className="PITM-title">
        <div className="PITM-titleArea">
          <p className="title">{text}</p>
        </div>
      </div>
      <div className="odArea">
        <ShowList list={list} />
      </div>
      <div className="commentArea">
        {comment}
      </div>
      <div className="horizontalLine" />
    </div>
  );
};

export default PcConfTitle;